/*
==========================================
Custom custom-all-item.liquid
==========================================
*/

document.addEventListener('DOMContentLoaded', function() {
  // ポップアップ表示制御の要素を取得
  const categoryBtn = document.querySelector('#all-item-menu-open-btn');
  const categoryPopup = document.querySelector('#all-item-menu');
  const categoryCloseBtn = document.querySelector('#all-item-menu-close-btn');

  // カテゴリーボタンクリック時の処理
  if (categoryBtn) {
    categoryBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (categoryPopup) {
        document.documentElement.classList.add('no-scroll'); 
        categoryPopup.setAttribute('aria-hidden', 'false');
      }
    });
  }

  // 閉じるボタンクリック時の処理
  if (categoryCloseBtn) {
    categoryCloseBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (categoryPopup) {
        categoryPopup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
      }
    });
  }
});